import { Styles } from "@/theme/theme.type";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { FaXTwitter as TwitterIcon } from "react-icons/fa6";
import { Link, Stack, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";

export const ShareWidget: FC<ShareWidgetProps> = ({ href }) => {
  const [url, setUrl] = useState<string | undefined>();

  useEffect(() => {
    setUrl(href);
  }, [href]);

  const styles = {
    link: {
      color: ({ palette }) => palette.grey[400],
      transition: ({ transitions }) =>
        transitions.create("color", {
          duration: transitions.duration.shortest,
          easing: transitions.easing.sharp
        }),
      "&:hover": {
        color: ({ palette }) => ({
          xs: palette.grey[400],
          sm: palette.text.primary
        })
      }
    },
    icon: {
      fontSize: 32,
      color: "inherit",
      display: "block"
    }
  } satisfies Styles;

  return (
    <Stack direction="row" spacing={{ xs: 2, sm: 3 }} alignItems="center">
      <Typography
        color="textSecondary"
        sx={{
          fontSize: "0.875rem",
          lineHeight: 1.4
        }}
      >
        Share
      </Typography>
      <Link
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
        sx={styles.link}
        target="_blank"
      >
        <LinkedInIcon sx={styles.icon} />
      </Link>
      <Link
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        sx={styles.link}
        target="_blank"
      >
        <FacebookIcon sx={styles.icon} />
      </Link>
      <Link
        href={`http://twitter.com/share?url=${url}`}
        sx={styles.link}
        target="_blank"
      >
        <TwitterIcon
          style={{ transform: "scale(1.7)", marginLeft: 4, marginTop: 7 }}
        />
      </Link>
    </Stack>
  );
};

export interface ShareWidgetProps {
  href: string;
}
